import { whatsappConfig } from "../whatsappConfig";

const WA_LINK_NUMBER = whatsappConfig.phoneNumber.replace(/[^0-9]/g, '');

export const SEO_CONFIG = {
    // Basic Identity
    orgName: "Uyirmozhy Publications",
    orgNameMalayalam: "ഉയിർമൊഴി പബ്ലിക്കേഷൻസ്",
    baseUrl: "https://uyirmozhy.in",

    defaultTitle: "Uyirmozhy Publications | Best Malayalam Books & Publishing",
    defaultDescription: "Uyirmozhy Publications: Buy premium Malayalam books online. We publish aspiring writers and promote knowledge and culture.",

    // Social Media Links
    social: {
        facebook: "https://www.facebook.com/uyirmozhy",
        instagram: "https://www.instagram.com/uyirmozhy",
        youtube: "https://youtube.com/@uyirmozhy",
        // Dynamically generated using your config
        whatsapp: `https://wa.me/${WA_LINK_NUMBER}`
    },

    // Contact Info
    contact: {
        phone: whatsappConfig.phoneNumber, // Uses "+91 7034382515"
        email: "uyirmozhy@gmail.com",
        addressLocality: "Venjaramoodu",
        addressRegion: "Thiruvananthapuram",
        addressCountry: "IN"
    },

    // Default JSON-LD Schema
    baseSchema: {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Uyirmozhy Publications",
        "url": "https://uyirmozhy.in",
        "logo": "https://uyirmozhy.in/logo.png", // Schema requires a Full HTTP URL, not an import
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": whatsappConfig.phoneNumber, // Uses "+91 7034382515"
            "contactType": "customer service",
            "areaServed": "IN",
            "availableLanguage": ["Malayalam", "English"]
        },
        "sameAs": [
            "https://www.facebook.com/uyirmozhy",
            "https://www.instagram.com/uyirmozhy",
            `https://wa.me/${WA_LINK_NUMBER}`
        ]
    }
};
